export const needToCompare = (comparison, key) => {
  if (!comparison || !comparison[key]) {
    return false;
  }
  return comparison[key][2];
};
